import React, { useState, useRef, useEffect } from 'react';
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import HamsterAnimation from '../animation/loader';
import { withAuthenticationRequired,useAuth0 } from '@auth0/auth0-react';
//import Trnanscript from './transcript';
import ShareToWhatsApp from './ShareToWhatsApp';
import DownloadPDF from './DownloadPDF';
import DownloadWord from './DownloadWord';
import Transcriptreceta from './transcriptreceta';

const Simple = ({chatResponse2,setchatResponse2,procedurResponse,setProcedureResponse}) => {
    const [chatresponse22, setchatresponse22] = useState(''); // Add a new state variable for the chat response
    const [procedureresponse22, setprocedureresponse22] = useState(''); // Add a new state variable for the chat response

  const [audioURL, setAudioURL] = useState(null); // Add a new state variable for the audio URL
  const recorderControls = useAudioRecorder();
  const { getAccessTokenSilently, user} = useAuth0();
  const [isLoading, setIsLoading] = useState(false);
  //add an array [] of strings to hold the chat responses
  
  //const [procedurResponse, setProcedureResponse] = useState('');
  const { name } = user;
  const pRef = useRef(null);
  const undo = () => {
    if (pRef.current) {
      pRef.current.innerHTML = chatResponse2;
    }
  };
  const [isEditing, setIsEditing] = useState(false);


  const onRecordingComplete = async (blob) => {
    setAudioURL(URL.createObjectURL(blob)); // Set the audio URL so the user can listen to the recording
  };
  const sendTextResponse = async () => {
    setIsLoading(true);
    if (chatResponse2 !== '') {
      try {
        const token = await getAccessTokenSilently();
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/print_text`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ text: "sintetizalo como record medico:\n"+chatResponse2 }), // Send the chatResponse2 as a JSON object
        });
  
        if (!response.body) {
          throw Error('Unsupported Response');
        }
  
        const reader = response.body.getReader();
        let chunks = '';
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            console.log('Completed');
            break;
          }
          chunks += new TextDecoder("utf-8").decode(value);
          setProcedureResponse(chunks.replace(/\n/g, '<br/>')); // Update the chatResponse2 state variable with the server's response
        }
      } catch (err) {
        console.log(err);
        setProcedureResponse("ERROR INESPERADO EN EL SERVIDOR, INTENTE ENVIAR TEXTO DE NUEVO");
      }
      finally {
        setIsLoading(false);
      }
    } else {
      console.log('Chat response is empty. Nothing to send.');
    }
  };
  
  const sendRecording = async () => {
    setIsLoading(true);
    setchatResponse2(''); // Clear the chat response
    const blob = await fetch(audioURL).then(r => r.blob());
    const formData = new FormData();
    const filename = `${name}-recording-procedure.webm`;
    // Convert blob to File
    const file = new File([blob], filename, {
      type: "audio/webm",
    });
    formData.append('avatar', file);
    console.log(file);
    // Rest of your fetch code here...
    try {
      const token = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/transcript`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });
  
      if (!response.ok) {
        throw Error('Server Error: ' + response.statusText);
      }
  
      const full_dialog = await response.text(); // Read the response text
      //console.log('Full dialog:', full_dialog);
      let modifiedDialog = full_dialog;
      modifiedDialog = modifiedDialog.replace(/, se realiza /g, ', \n\nse realiza ');
      modifiedDialog = modifiedDialog.replace(/, se identifica /g, ', \n\nse identifica ');
      modifiedDialog = modifiedDialog.replace(/, se coloca /g, ', \nse coloca ');
      setchatResponse2(modifiedDialog.replace(/\n/g, '<br/>'));// Update the chatResponse2 state variable with the server's response
    } catch(err) {
      console.log(err);
      setchatResponse2("ERROR INESPERADO EN EL SERVIDOR, INTENTE ENVIAR AUDIO DE NUEVO");
    }
    finally {
      setIsLoading(false);
    }
  };
  const finalizeEdit = () => {
    if (pRef.current) {
      const updatedContent = pRef.current.innerHTML.replace(/<br\/>/g, '\n');
      setchatResponse2(updatedContent);
      //console.log(updatedContent);
    }
  };



 
  

  return (
    
      <div className='para_transcrip_simple'>
        <h3 className='parah1n1'>Registro Médico</h3>
        {isLoading && <HamsterAnimation />}
      <div className='apps-card'>
      <div className="app-card2">
        <span>Grabar Procedimiento:</span>
        <div className='content-section'>
        <AudioRecorder 
            onRecordingComplete={(blob) => onRecordingComplete(blob)}
            recorderControls={recorderControls}
            downloadOnSavePress={false}
            downloadFileExtension="webm"
            showVisualizer={true}
            audioTrackConstraints={{
              autoGainControl: true,
              echoCancellation: true,
              noiseSuppression: true,
            }}
            classes={{
              root: 'audio-recorder-root',
              controls: 'audio-recorder-controls',
              visualizer: 'audio-recorder-visualizer',
            }}
          />  
        
      </div>
      <div className='content-section'>
      {audioURL && (
        <div className="audio-controls">
          
          <audio src={audioURL} controls />
          <button className="send-recording-btn" onClick={sendRecording}>Send recording</button>
        </div>
      )}
      </div>
      </div> 
      

      <div className="app-card2">
      <span>Procedimiento:</span>
      <div className='transcription'>
        
        <p className="app-card2__subtext" 
          contentEditable={isEditing} 
          ref={pRef}
            dangerouslySetInnerHTML={{ __html: chatResponse2 }}
            ></p> 
            {isEditing && (
              <button className='content-button' onClick={undo}>
                ↺ 
              </button>
            )}
          <button className={isEditing ? 'content-button-logout':'content-button-login'} onClick={() => {
                if (isEditing) {
                  finalizeEdit();
                }
                setIsEditing(!isEditing);
              }}>
              {isEditing ? 'Finalizar' : 'Editar'}
          </button>


        </div>
    {chatResponse2 !== '' && (
        <div className="app-card2-buttons">
        <button onClick={sendTextResponse} className="content-button status-button open">Sintetizar</button>
        <div className="menu"></div>
       </div>
      
    )}
    {procedurResponse !== '' && (
        <div>
    <span>Sintesis:</span>
      <div className='transcription'>
   
      <p className="app-card2__subtext" dangerouslySetInnerHTML={{ __html: procedurResponse }}></p>
      
      </div>
      </div>
    )}
   
 

</div>
</div>
<div className='content-section'></div>
<h3 className='parah1n1'>Recetea, observaciones, recomendaciones</h3>
<Transcriptreceta chatResponse2={chatresponse22}
setchatResponse2={setchatresponse22}
procedurResponse={procedureresponse22}
setProcedureResponse={setprocedureresponse22}
chatResponse={chatResponse2}
chatresponseraw={procedurResponse}/>

</div>
      
      
    
  );
};

export default Simple;
